module.exports = __webpack_public_path__ + "static/media/mmsys_114.fdb5b556.ico";